const parse = value => typeof value === 'string' ? JSON.parse(value) : value;

export const getSavedMapping = value => {
    const mapping = parse(value);
    return Array.isArray(mapping) && mapping.length > 0 ? mapping : null;
};

// The columns endpoint uses the same source-column structure as the wizard.
export const getSelectedMapping = data => {
    const selected = parse(data.selected_columns) || {};
    const extras = parse(data.extra_columns) || [];
    const mapping = Object.keys(selected).map(column => ({
        column,
        name: selected[column].column,
    }));
    Object.values(extras).forEach(extra => {
        if (!mapping.some(item => item.column === extra.column)) {
            mapping.push({column: extra.column, name: extra.column});
        }
    });
    return getSavedMapping(mapping);
};

export const getMappedPreview = (preview, mapping) => {
    const data = parse(preview) || {};
    return Object.fromEntries(mapping.map(({column, name}) => [
        column,
        // The wizard maps a target column to the selected source name.
        Object.prototype.hasOwnProperty.call(data, name) ? data[name] : (data[column] || []),
    ]));
};
